import React, { useState, useEffect } from "react";
import apiClient from "../api/apiClient";

const NuevoCliente = () => {
    const [formData, setFormData] = useState({
        CardCode: "",
        CardName: "",
        CardForeignName: "",
        FederalTaxID: "",
        CardType: "C", // Cliente por defecto
        GroupCode: "",
        GroupName: "",
        Phone1: "",
        EmailAddress: "",
        U_GLN: "",
        U_tipoidentificacion: "",
        FatherCard: "",
        PriceListNum: "",
        U_Canal_2: "",
        U_Cadena: "",
        U_Zona: "",
        BPAddresses: [
            {
                AddressName: "",
                Street: "",
                ZipCode: "",
                AddressType: "bo_BillTo", // Predeterminado como dirección de facturación
            },
        ],
    });

    const [groups, setGroups] = useState([]);
    const [priceLists, setPriceLists] = useState([]);
    const [canales, setCanales] = useState([]);
    const [zonas, setZonas] = useState([]);
    const [cadenas, setCadenas] = useState([]);
    const [ciudades, setCiudades] = useState([]);
    const [message, setMessage] = useState("");
    const [error, setError] = useState("");
    const [tipoIdentificaciones, setTipoIdentificaciones] = useState([
        { code: "11", description: "RUC" },
        { code: "12", description: "CEDULA" },
        { code: "13", description: "PASAPORTE" },
        { code: "14", description: "CEDULA EXTRANJERA" },
        { code: "15", description: "SIN NOMBRE" },
        { code: "16", description: "DIPLOMATICO" },
        { code: "17", description: "IDENTIFICACION TRIBUTARIA" },
        { code: "18", description: "CLIENTE DEL EXTERIOR" },
    ]);
    const [databases, setDatabases] = useState([]);

    useEffect(() => {
        const fetchInitialData = async () => {
            try {
                const databasesresponse = await apiClient.get("/databases");
                const groupsResponse = await apiClient.get("/groups");
                const priceListsResponse = await apiClient.get("/price-lists");
                const canalesResponse = await apiClient.get("/canales");
                const zonasResponse = await apiClient.get("/zonas");
                const cadenasResponse = await apiClient.get("/cadenas");
                const ciudadesResponse = await apiClient.get("/ciudades");
                const nextCodeResponse = await apiClient.get("/next-business-partner-code");

                setFormData((prevData) => ({
                    ...prevData,
                    CardCode: nextCodeResponse.data.next_code, // Asignar el siguiente código
                }));
                setGroups(groupsResponse.data);
                setPriceLists(priceListsResponse.data);
                setCanales(canalesResponse.data);
                setZonas(zonasResponse.data);
                setCadenas(cadenasResponse.data);
                setCiudades(ciudadesResponse.data);
                setDatabases(databasesresponse.data);
            } catch (err) {
                setError("Error al cargar los datos iniciales. Intenta nuevamente.");
            }
        };
        fetchInitialData();
    }, []);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const handleAddressChange = (e) => {
        const { name, value } = e.target;
        const updatedAddresses = [...formData.BPAddresses];
        updatedAddresses[0][name] = value;
        setFormData({ ...formData, BPAddresses: updatedAddresses });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        // Obtener credenciales desde localStorage
        const sapUser = JSON.parse(localStorage.getItem("sapUser"));
        if (!sapUser) {
            setError("Credenciales no disponibles. Por favor, inicie sesión nuevamente.");
            return;
        }

        const dataToSend = {
            data: {
                ...formData,
                PriceListNum: parseInt(formData.PriceListNum, 10),
            },
            credentials: sapUser, // Enviar credenciales al backend
        };

        try {
            const response = await apiClient.post("/business-partners", dataToSend);
            setMessage("Cliente creado exitosamente");
            setError("");
        } catch (err) {
            if (err.response && err.response.data && err.response.data.error) {
                setError(err.response.data.error);
            } else {
                setError("Error inesperado. Por favor, inténtalo nuevamente.");
            }
            setMessage("");
        }
    };

    return (
        <div className="container mt-4">
            <h2>Crear Nuevo Cliente</h2>
            {message && <div className="alert alert-success">{message}</div>}
            {error && <div className="alert alert-danger">{error}</div>}

            {/* Mostrar las bases de datos configuradas */}
            <div className="mt-3">
                <h5 style={{ fontSize: "1.0rem" }}>Bases de datos configuradas:</h5>
                <ul>
                    {databases.map((db, index) => (
                        <li key={index} style={{ fontSize: "0.7rem" }}>
                            <strong>{db.CompanyDB}</strong>
                        </li>
                    ))}
                </ul>
            </div>

            <form onSubmit={handleSubmit}>
                {/* Fila 1: Serie y Nombre */}
                <div className="row">
                    <div className="col-md-3">
                        <label htmlFor="CardCode">Código de Cliente</label>
                        <input
                            type="text"
                            className="form-control"
                            id="CardCode"
                            name="CardCode"
                            value={formData.CardCode}
                            readOnly
                        />
                    </div>
                    <div className="col-md-6">
                        <label htmlFor="CardName">Nombre del Cliente</label>
                        <input
                            type="text"
                            className="form-control"
                            id="CardName"
                            name="CardName"
                            value={formData.CardName}
                            onChange={handleChange}
                            required
                        />
                    </div>

                    <div className="col-md-3">
                        <label htmlFor="U_tipoidentificacion">Tipo de Identificación</label>
                        <select
                            className="form-control"
                            id="U_tipoidentificacion"
                            name="U_tipoidentificacion"
                            value={formData.U_tipoidentificacion}
                            onChange={handleChange}
                            required
                        >
                            <option value="">Seleccione un tipo</option>
                            {tipoIdentificaciones.map((tipo) => (
                                <option key={tipo.code} value={tipo.code}>
                                    {tipo.description}
                                </option>
                            ))}
                        </select>
                    </div>
                </div>

                {/* Fila 2: Nombre de Fantasía y Documento Fiscal */}
                <div className="row mt-3">
                    <div className="col-md-3">
                        <label htmlFor="CardForeignName">Nombre de Fantasía</label>
                        <input
                            type="text"
                            className="form-control"
                            id="CardForeignName"
                            name="CardForeignName"
                            value={formData.CardForeignName}
                            onChange={handleChange}
                        />
                    </div>
                    <div className="col-md-3">
                        <label htmlFor="FederalTaxID">Documento Fiscal</label>
                        <input
                            type="text"
                            className="form-control"
                            id="FederalTaxID"
                            name="FederalTaxID"
                            value={formData.FederalTaxID}
                            onChange={handleChange}
                            required
                        />
                    </div>
                    <div className="col-md-3">
                        <label htmlFor="U_GLN">GLN</label>
                        <input
                            type="text"
                            className="form-control"
                            id="U_GLN"
                            name="U_GLN"
                            value={formData.U_GLN}
                            onChange={handleChange}
                        />
                    </div>
                    <div className="col-md-3">
                        <label htmlFor="EmailAddress">Correo Electrónico</label>
                        <input
                            type="email"
                            className="form-control"
                            id="EmailAddress"
                            name="EmailAddress"
                            value={formData.EmailAddress}
                            onChange={handleChange}
                        />
                    </div>
                </div>

                {/* Fila 3: Teléfono y Dirección */}
                <div className="row mt-3">
                    <div className="col-md-3">
                        <label htmlFor="Phone1">Teléfono</label>
                        <input
                            type="text"
                            className="form-control"
                            id="Phone1"
                            name="Phone1"
                            value={formData.Phone1}
                            onChange={handleChange}
                        />
                    </div>
                    <div className="col-md-3">
                        <label htmlFor="AddressName">Nombre de la Dirección</label>
                        <input
                            type="text"
                            className="form-control"
                            id="AddressName"
                            name="AddressName"
                            value={formData.BPAddresses[0].AddressName}
                            onChange={handleAddressChange}
                            required
                        />
                    </div>
                    <div className="col-md-3">
                        <label htmlFor="Street">Calle</label>
                        <input
                            type="text"
                            className="form-control"
                            id="Street"
                            name="Street"
                            value={formData.BPAddresses[0].Street}
                            onChange={handleAddressChange}
                            required
                        />
                    </div>
                    <div className="col-md-3">
                        <label htmlFor="ZipCode">Código Ciudad SET</label>
                        <select
                            className="form-control"
                            id="ZipCode"
                            name="ZipCode"
                            value={formData.BPAddresses[0].ZipCode}
                            onChange={handleAddressChange}
                            required
                        >
                            <option value="">Seleccione una ciudad</option>
                            {ciudades.map((ciudad) => (
                                <option key={ciudad.Code} value={ciudad.Code}>
                                    {ciudad.Name}
                                </option>
                            ))}
                        </select>
                    </div>
                </div>

                {/* Fila 5: Listas desplegables */}
                <div className="row mt-3">
                    <div className="col-md-4">
                        <label htmlFor="GroupName">Grupo</label>
                        <select
                            className="form-control"
                            id="GroupName"
                            name="GroupName"
                            value={formData.GroupName}
                            onChange={handleChange}
                            required
                        >
                            <option value="">Seleccione</option>
                            {groups.map((group) => (
                                <option key={group.Name} value={group.Name}>
                                    {group.Name}
                                </option>
                            ))}
                        </select>
                    </div>

                    <div className="col-md-4">
                        <label htmlFor="PriceListNum">Lista de Precios</label>
                        <select
                            className="form-control"
                            id="PriceListNum"
                            name="PriceListNum"
                            value={formData.PriceListNum}
                            onChange={handleChange}
                            required
                        >
                            <option value="">Seleccione</option>
                            {priceLists.map((list) => (
                                <option key={list.ListNum} value={list.ListNum}>
                                    {list.PriceListName}
                                </option>
                            ))}
                        </select>
                    </div>
                    <div className="col-md-4">
                        <label htmlFor="U_Canal_2">Canal</label>
                        <select
                            className="form-control"
                            id="U_Canal_2"
                            name="U_Canal_2"
                            value={formData.U_Canal_2}
                            onChange={handleChange}
                            required
                        >
                            <option value="">Seleccione</option>
                            {canales.map((canal) => (
                                <option key={canal.Code} value={canal.Code}>
                                    {canal.Name}
                                </option>
                            ))}
                        </select>
                    </div>
                </div>

                {/* Fila 6: Zona y Cadena */}
                <div className="row mt-3">
                    <div className="col-md-4">
                        <label htmlFor="U_Zona">Zona</label>
                        <select
                            className="form-control"
                            id="U_Zona"
                            name="U_Zona"
                            value={formData.U_Zona}
                            onChange={handleChange}
                            required
                        >
                            <option value="">Seleccione</option>
                            {zonas.map((zona) => (
                                <option key={zona.Code} value={zona.Code}>
                                    {(zona.U_ZONA_2 || '') + ' - ' + (zona.U_ZONA_3 || '') + ' - ' + (zona.Name || '') + ' - ' + (zona.U_ZONA_4 || '')}
                                </option>
                            ))}
                        </select>
                    </div>
                    <div className="col-md-4">
                        <label htmlFor="U_Cadena">Cadena</label>
                        <select
                            className="form-control"
                            id="U_Cadena"
                            name="U_Cadena"
                            value={formData.U_Cadena}
                            onChange={handleChange}
                            required
                        >
                            <option value="">Seleccione</option>
                            {cadenas.map((cadena) => (
                                <option key={cadena.Code} value={cadena.Code}>
                                    {cadena.Name}
                                </option>
                            ))}
                        </select>
                    </div>
                    <div className="col-md-4">
                        {/* Botón de envío */}
                        <button type="submit" className="btn btn-primary mt-4">
                            Crear Cliente
                        </button>
                    </div>
                </div>
            </form>
        </div>
    );
};

export default NuevoCliente;
